import { theme as baseTheme } from '../aidu/index.js';
export const colors = {
  ...baseTheme.colors,
  contentBrand: '#F15A22',
  interactionPrimary: '#F15A22',
  interactionPrimaryHover: '#C94503',
  interactionSecondary: '#404040',
  interactionSecondaryHover: '#1A1A1A',
  backgroundBrand: '#F15A22',
  backgroundBrandDark: '#C94503',
  backgroundInteractionSecondaryTransparentDark: '#404040CC',
  backgroundInteractionSecondaryTransparentLight: '#4040404D',
  backgroundStateSelectedTransparent: '#4040401A',
  backgroundStateSelected: '#FEF3E6',
  backgroundOverlay: '#000000CC',
  borderSelection: '#F15A22',
  brandA: '#F15A22'
};